import UploadContent from "./upload-content";

export default UploadContent;